<template>
  <footer class="bg-gradient-to-r from-marbel-gray to-marbel-gray-light text-white py-6 mt-auto">
    <div class="max-w-6xl mx-auto px-6">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <!-- Logo y información principal -->
        <div class="flex items-center space-x-4 mb-4 md:mb-0">
          <div class="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
            <span class="text-white font-bold text-lg">M</span>
          </div>
          <div>
            <h3 class="font-bold text-lg">MARBEL</h3>
            <p class="text-white/80 text-sm">Transformando Espacios En Hogares</p>
          </div>
        </div>

        <!-- Información de la empresa -->
        <div class="text-center md:text-right">
          <div class="flex flex-col md:flex-row items-center gap-4 text-sm">
            <div class="flex items-center space-x-2">
              <svg class="w-4 h-4 text-marbel-yellow" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              <span class="text-white/90">18+ años de experiencia</span>
            </div>
            <div class="flex items-center space-x-2">
              <svg class="w-4 h-4 text-green-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/>
              </svg>
              <span class="text-white/90">Monterrey, N.L.</span>
            </div>
          </div>
          <div class="mt-2 text-xs text-white/70">
            © {{ currentYear }} MARBEL. Todos los derechos reservados.
          </div>
        </div>
      </div>

      <!-- Divider -->
      <hr class="border-white/20 my-4">

      <!-- Bottom row -->
      <div class="flex flex-col md:flex-row justify-between items-center text-sm">
        <div class="flex items-center space-x-4 mb-2 md:mb-0">
          <span class="text-white/80">Sistema v3.1</span>
          <div class="flex items-center space-x-1">
            <div class="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
            <span class="text-white/80">Estado: Activo</span>
          </div>
        </div>
        
        <!-- Powered by -->
        <div class="flex items-center space-x-2">
          <span class="text-white/70 text-xs">Powered by</span>
          <a 
            href="https://www.instagram.com/popcingmx/" 
            target="_blank" 
            class="bg-black hover:bg-gray-900 text-marbel-yellow px-3 py-1 rounded-full text-xs font-bold transition-colors"
          >
            Popcing
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MarbelFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
/* Animaciones adicionales para el footer */
@keyframes pulse-soft {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

.animate-pulse-soft {
  animation: pulse-soft 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
